// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1lSww","footer":"ModalUpdate_footer__3dOxA"};